// extracted by mini-css-extract-plugin
export default {"container":"style_container__3vuKv","titleSection":"style_titleSection__G7VZh"};